import React from 'react';

const ReturnPolicyView = () => {
    return (
        <div className="bg-white p-8 rounded-lg shadow-xl max-w-4xl mx-auto my-8">
            <h1 className="text-3xl font-bold text-sky-700 mb-6">Return & Refund Policy</h1>
            <p className="text-gray-500 mb-4 text-sm">Last Updated: June 2026</p>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Return Eligibility</h2>
                    <p>Medicines can be returned if they are damaged during transit, have expired, or if the wrong medicine was delivered. Items must be in their original packaging with an intact seal.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Non-Returnable Items</h2>
                    <p>Temperature-sensitive items (like insulin), opened bottles/syrups, and items requiring special storage conditions are generally not eligible for return once delivered for safety reasons.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Return Timeline</h2>
                    <p>Please report any discrepancies within 48 hours of delivery to initiate a return request.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Refunds</h2>
                    <p>Approved refunds will be processed within 5-7 working days to the original payment method or as store credit, as per your preference.</p>
                </section>
            </div>
        </div>
    );
};

export default ReturnPolicyView;
